import React from 'react';

import { Link } from 'react-router-dom';

import * as WebRoutes from '../../web-routes';

// If the organization has access to an org level forwarding number (they have an org level job number) show them one of two messages when editing the job forwarding number
// 1. If they have not set up the org level forwarding number or a job level forwarding number, tell them to use it -> NoDefaultMessage
// 2. If they have set up the org level forwarding number but no job level forwarding number, tell them how to edit both -> UsingDefaultMessage
// 3. If there is a job level forwarding number, say nothing
const NoDefaultMessage = ({ org }: { org: Org }) => (
  <div>
    The default applicant forwarding configuration is located in your organization&apos;s settings.
    You currently don&apos;t have one; please go{' '}
    <Link className="typo-link" to={WebRoutes.orgSettingsRoute(org.org_id)}>
      here to set it up.
    </Link>
  </div>
);

const UsingDefaultMessage = ({ org }: { org: Org }) => (
  <div>
    This job uses the default applicant forwarding configuration. This number is located in your
    organization&apos;s settings; please go{' '}
    <Link className="typo-link" to={WebRoutes.orgSettingsRoute(org.org_id)}>
      here to edit.{' '}
    </Link>
    Click the pencil above to enter a phone number for applicants of this job to be forwarded to
    instead.
  </div>
);

export const DefaultNumberMessage = ({ org, job }: { org: Org; job: Partial<Job> }) => {
  const hasOrgJobPhoneNumber = !!org.jobPhoneNumber;
  const isUsingJobSpecificForwardingNumber = !!job.forwardingPhoneNumberForCalls;
  const hasOrgLevelForwardingNumber = !!org.jobForwardingPhoneNumber && !!org.jobPhoneNumber;

  if (isUsingJobSpecificForwardingNumber || !hasOrgJobPhoneNumber) {
    return <div />;
  }

  return hasOrgLevelForwardingNumber ? (
    <UsingDefaultMessage org={org} />
  ) : (
    <NoDefaultMessage org={org} />
  );
};

export const EditingStateDefaultNumberMessage = () => (
  <div className="typo-subtitle">
    The default applicant forwarding configuration is located in your organization&apos;s settings.
  </div>
);
